import React from 'react';
import { Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Constants } from '../utils';
import Menu from 'screens/menu';
import { RootState } from 'reducers';

const _Route = (props: any) => {
  const history = useHistory();
  const location = useLocation();
  const module_permissions =
    props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];

  if (!props.user && (props.auth || props.admin || props.client || props.lawyer)) {
    // Conservamos a dónde intentaba ir el usuario (path + query) en "next"
    // para poder volver ahí después de iniciar sesión.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Redirect to={{ pathname: '/login', search: `?next=${next}` }} />;
  } else if (
    props.user &&
    props.admin &&
    props.user.level_id != Constants.LEVELS.ADMIN &&
    props.user.level_id != Constants.LEVELS.MODERATOR
  ) {
    return <Redirect to='/' />;
  } else if (props.user && props.client && props.user.level_id != Constants.LEVELS.CLIENT) {
    return <Redirect to='/' />;
  } else if (props.user && props.lawyer && props.user.level_id != Constants.LEVELS.LAWYER) {
    return <Redirect to='/' />;
  } else if (props.user && props.user.level_id == Constants.LEVELS.MODERATOR && props.permission) {
    if (typeof props.permission === 'number') {
      if (module_permissions.indexOf(props.permission) == -1) {
        return <Redirect to='/' />;
      }
    } else if (Array.isArray(props.permission)) {
      let value = false;
      props.permission.forEach((item: number) => {
        if (!value) value = module_permissions.indexOf(props.permission) != -1;
      });
      if (!value) {
        return <Redirect to='/' />;
      }
    }
  } else if (props.user && props.noAuth) {
    // Si ya está logueado y llega a una pantalla "noAuth" (ej. /login) con un
    // "next" (ej. desde el link de membresías), lo respetamos en vez de
    // mandarlo siempre a "/".
    const params = new URLSearchParams(location.search);
    const next = params.get('next');
    return <Redirect to={next ? decodeURIComponent(next) : '/'} />;
  }
  if (
    props.user &&
    (props.auth || props.admin || props.lawyer || props.client) &&
    !props.withoutFrame
  ) {
    return (
      <Menu history={history}>
        <Route {...props} />
      </Menu>
    );
  } else {
    return <Route {...props} />;
  }
};

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(_Route);
